import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SSOProvider} from '@app/models/auth/sso-provider.enum';
import {ButtonShape, ButtonType} from '@app/shared/components/inputs/button/button.component';
import {AuthMessages} from '@app/auth/auth.messages';
import {HRLOCKER, SignInProvider} from '@app/models/auth/sign-in-provider';

const PROVIDER_DISPLAY: Record<SignInProvider, { name: string; logo: string }> = {
  [SSOProvider.MICROSOFT]: { name: 'Microsoft', logo: 'assets/img/sso/microsoft.png' },
  [SSOProvider.GOOGLE]: { name: 'Google', logo: 'assets/img/sso/google.png' },
  [HRLOCKER]: { name: 'HRLocker', logo: 'assets/img/sso/hrlocker.svg' }
};

@Component({
  selector: 'app-login-sso-component',
  templateUrl: './login-sso.component.html',
})
export class LoginSSOComponent {
  public readonly eButtonType = ButtonType;
  public readonly eButtonShape = ButtonShape;
  public readonly eAuthMessages = AuthMessages;

  @Input() public provider!: SignInProvider;

  // The label's translation key, given the provider name as {{provider}} so each language puts it where it belongs: the
  // calendar connect in Settings passes "Connect with {{provider}}"; without one it is the login page's sign-in label.
  @Input() public labelKey?: string;

  @Output() public readonly buttonClick = new EventEmitter<SignInProvider>();

  public get providerName(): string {
    return PROVIDER_DISPLAY[this.provider].name;
  }

  public get logoSrc(): string {
    return PROVIDER_DISPLAY[this.provider].logo;
  }

  login(): void {
    this.buttonClick.emit(this.provider);
  }
}
